import axios from 'axios';
import React, { useContext, useEffect } from 'react';
import { GlobalContext } from '../context/GlobalContext';
import { useParams } from 'react-router-dom';
import RadioBtn from './RadioBtn';

function DataForm() {
  let { IdData } = useParams();
  const { contextState, contextFunctions } = useContext(GlobalContext);
  const { input, setInput, selected, dataRadio, setSelected } = contextState;

  const { handleInput, handleSubmit, handleRadioButton } = contextFunctions;

  useEffect(() => {
    console.log(IdData);
    if (IdData !== undefined) {
      axios
        .get(`https://dev-example.sanbercloud.com/api/job-vacancy/${IdData}`)
        .then((response) => {
          console.log(response);
          setInput({
            title: response.data.title,
            job_description: response.data.job_description,
            job_qualification: response.data.job_qualification,
            job_type: response.data.job_type,
            job_tenure: response.data.job_tenure,
            company_name: response.data.company_name,
            company_image_url: response.data.company_image_url,
            company_city: response.data.company_city,
            salary_min: response.data.salary_min,
            salary_max: response.data.salary_max,
            job_status: response.data.job_status,
          });
        });
    }
  }, []);

  return (
    <div className="col-10">
      <h1 className="text-center">Form Data</h1>
      <form onSubmit={handleSubmit} className="row g-3">
        <div className="col-12">
          <label htmlFor="title" className="form-label">
            Pekerjaan
          </label>
          <input
            type="text"
            className="form-control"
            id="title"
            onChange={handleInput}
            value={input.title}
            name="title"
            placeholder="pekerjaan..."
          />
        </div>

        <div className=" col-12">
          <label htmlFor="job_description" className="form-label">
            Deskripsi
          </label>
          <textarea
            type="text"
            className="form-control"
            id="job_description"
            onChange={handleInput}
            value={input.job_description}
            name="job_description"
            placeholder="Deskripsi..."
          ></textarea>
        </div>

        <div className=" col-md-6">
          <label htmlFor="job_qualification" className="form-label">
            Kualifikasi Pekerjaan
          </label>
          <input
            type="text"
            className="form-control"
            id="job_qualification"
            onChange={handleInput}
            value={input.job_qualification}
            name="job_qualification"
            placeholder="Kualifikasi pekerjaan..."
          />
        </div>

        <div className=" col-md-6">
          <label htmlFor="job_type" className="form-label">
            Tipe Pekerjaan
          </label>
          <input
            type="text"
            className="form-control"
            id="job_type"
            onChange={handleInput}
            value={input.job_type}
            name="job_type"
            placeholder="WFO/ WFH/ WFA..."
          />
        </div>

        <div className=" col-md-6">
          <label htmlFor="job_tenure" className="form-label">
            Kontrak Pekerjaan
          </label>
          <input
            type="text"
            className="form-control"
            id="job_tenure"
            onChange={handleInput}
            value={input.job_tenure}
            name="job_tenure"
            placeholder="Kontrak/ magang/ tetap..."
          />
        </div>

        <div className=" col-md-6">
          <label htmlFor="company_name" className="form-label">
            Nama Perusahaan
          </label>
          <input
            type="text"
            className="form-control"
            id="company_name"
            onChange={handleInput}
            value={input.company_name}
            name="company_name"
            placeholder="Nama Perusahaan..."
          />
        </div>

        <div className=" col-md-6">
          <label htmlFor="company_image_url" className="form-label">
            Link foto Perusahaan(link)
          </label>
          <input
            type="text"
            className="form-control"
            id="company_image_url"
            onChange={handleInput}
            value={input.company_image_url}
            name="company_image_url"
            placeholder="Foto Perusahaan..."
          />
        </div>

        <div className=" col-md-6">
          <label htmlFor="company_city" className="form-label">
            Kota Perusahaan
          </label>
          <input
            type="text"
            className="form-control"
            id="company_city"
            onChange={handleInput}
            value={input.company_city}
            name="company_city"
            placeholder="Kota Perusahaan..."
          />
        </div>

        <div className=" col-md-4">
          <label htmlFor="salary_min" className="form-label">
            Gaji Minimal
          </label>
          <input
            type="number"
            className="form-control"
            id="salary_min"
            onChange={handleInput}
            value={input.salary_min}
            name="salary_min"
            placeholder="Gaji Minimal..."
          />
        </div>

        <div className="col-md-4">
          <label htmlFor="salary_max" className="form-label">
            Gaji Maksimal
          </label>
          <input
            type="number"
            className="form-control"
            id="salary_max"
            onChange={handleInput}
            value={input.salary_max}
            name="salary_max"
            placeholder="Gaji Maksimal..."
          />
        </div>

        <div className="col-md-4">
          <label htmlFor="job_status" className="form-label">
            Status Pekerjaan
          </label>
          <input
            type="number"
            className="form-control"
            id="job_status"
            onChange={handleInput}
            value={input.job_status}
            name="job_status"
            placeholder="0/1"
            min="0"
            max="1"
          />
        </div>

        <button
          type="submit"
          className="ButtonForm btn btn-primary my-5 fw-semibold rounded-pill"
        >
          Submit
        </button>
      </form>
    </div>
  );
}

export default DataForm;
